import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import {
  Dropdown,
  Header,
  Grid,
  Button,
  Icon,
} from 'semantic-ui-react';
import Phone from './Phone';
import NotificationIcon from './Bookings/LeadActivity/NotificationIcon';
import { REJECTED_STATUSES } from '../constants/bankCaseStatuses';

class BuyerBankerCard extends Component {
  static propTypes = {
    data: PropTypes.shape({
      bankCase: PropTypes.object,
    }),
    bankCaseStates: PropTypes.shape({
      data: PropTypes.array,
    }),
    isSold: PropTypes.bool,
    disabled: PropTypes.bool,
    onChangeStatus: PropTypes.func,
    onMessage: PropTypes.func,
    onNudge: PropTypes.func,
  }
  static defaultProps = {
    disabled: false,
  }
  static mapStateToProps = state => ({
    bankCaseStates: state.bankCaseStates,
  })
  getStatusColor = (status) => {
    switch (status) {
      case 'pending_unreachable':
      case 'pending_docs':
      case 'pending_docs_submitted':
      case 'pending_reappealed':
        return 'status-pending';

      case 'new':
        return 'status-new';

      case 'approved_lo_issued':
        return 'status-approved';

      case 'reject_wrong_info':
      case 'reject_bank':
      case 'reject_developer':
      case 'reject_cancelled':
      case 'reject_customer':
      case 'reject_unqualified':
      case 'reject_lo_signed_other_bank':
        return 'status-reject';

      case 'success_li_issued':
        return 'status-success';

      default:
        return 'status-default';
    }
  };
  getOptions = () => {
    const { data, bankCaseStates } = this.props;
    const { bankCase } = data;
    if (bankCaseStates) {
      return bankCaseStates.data
      .filter(s => s.state === bankCase.previousStatus || s.state === bankCase.status || s.state === 'reject_developer')
      .map((s, key) => ({
        key,
        text: s.shortName,
        value: s.state,
        name: s.state,
        disabled: s.state !== bankCase.previousStatus && s.state !== 'reject_developer',
      }));
    }
    return [];
  }
  handleOnChange = (e, { value }) => {
    const { data, onChangeStatus } = this.props;
    if (onChangeStatus) {
      onChangeStatus(e, data.bankCase, value);
    }
  }
  handleOnMessage = (e) => {
    const { data, onMessage } = this.props;
    if (onMessage) {
      onMessage(e, data);
    }
  }
  handleOnNudge = (e) => {
    const { data, onNudge } = this.props;
    if (onNudge) {
      onNudge(e, data.bankCase);
    }
  }
  renderButtons = () => {
    const { data, disabled, isSold, onMessage, onNudge } = this.props;
    const { bankCase } = data;
    return (
      <Grid className="actions">
        <Grid.Column textAlign="center">
          <Button
            as="a"
            icon
            circular
            size="small"
            color="blue"
            href={`tel:+${bankCase.banker.mobilePrefix}${bankCase.banker.mobile}`}
          >
            <Icon name="phone" size="big" />
            <span>Call</span>
          </Button>
        </Grid.Column>
        {
          onMessage ? (
            <Grid.Column textAlign="center">
              <Button
                icon
                circular
                size="small"
                color="blue"
                onClick={this.handleOnMessage}
                disabled={disabled}
              >
                <Icon name="comments" size="big" />
                <span>Message</span>
              </Button>
            </Grid.Column>
          ) : null
        }
        {
          onNudge ? (
            <Grid.Column textAlign="center">
              <Button
                icon
                circular
                size="small"
                color="blue"
                onClick={this.handleOnNudge}
                disabled={disabled ||
                  isSold ||
                  bankCase.status.startsWith('success') ||
                  bankCase.status.startsWith('reject') ||
                  moment().isBefore(bankCase.nudgeAt)
                }
              >
                <NotificationIcon status="nudge" />
                <span>Nudge</span>
              </Button>
            </Grid.Column>
          ) : null
        }
      </Grid>
    );
  }
  render() {
    const { data, isSold, disabled, onChangeStatus } = this.props;
    const { bankCase } = data;
    const isReject = REJECTED_STATUSES.some(s => s === bankCase.status);
    const statusColor = this.getStatusColor(bankCase.status);
    return (
      <div className={`buyer-banker-card ${isReject ? 'cancelled' : ''}`}>
        <Header as="h4">{bankCase.banker.name}</Header>
        <Phone
          mobilePrefix={bankCase.banker.mobilePrefix}
          mobile={bankCase.banker.mobile}
        />
        {!isReject ? this.renderButtons() : null}
        <Dropdown
          selectOnBlur={false}
          fluid
          floating
          scrolling
          className={`icon ${statusColor}`}
          selection
          onChange={this.handleOnChange}
          options={this.getOptions()}
          value={bankCase.status}
          disabled={disabled || isSold || isReject || !onChangeStatus}
        />
      </div>
    );
  }
}

export default connect(BuyerBankerCard.mapStateToProps)(BuyerBankerCard);



// WEBPACK FOOTER //
// ./src/components/BuyerBankerCard.jsx